import ConstantDataGridString from "../constantDataGridString";

const computedPageFromParams = (params) => {
    return params.endRow / ConstantDataGridString.DATA_GRID_PAGE_SIZE
}
export default {computedPageFromParams};